import React from 'react';
import { ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { fs } from "../../theme/designLintTokens";
const NAV_RADIUS = 10;
const NAV_TRANSITION_MS = 200;
const NavItem = ({
  label,
  icon,
  selected,
  onClick
}) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const navTransition = theme.transitions.create(['background-color', 'color', 'box-shadow'], {
    duration: NAV_TRANSITION_MS,
    easing: theme.transitions.easing.easeInOut
  });
  const defaultColor = isDark ? 'rgba(255, 255, 255, 0.6)' : theme.palette.text.secondary;
  const defaultIcon = isDark ? 'rgba(255, 255, 255, 0.5)' : theme.palette.text.secondary;
  const hoverBg = isDark ? 'rgba(255, 255, 255, 0.05)' : 'rgba(15, 23, 42, 0.05)';
  const activeBg = 'rgba(99, 102, 241, 0.12)';
  const activeText = isDark ? '#ffffff' : theme.palette.primary.main;
  const activeIcon = isDark ? '#ffffff' : theme.palette.primary.main;
  return <ListItem disablePadding sx={{
    mb: 0.75
  }}>
      <ListItemButton onClick={onClick} selected={selected} disableRipple sx={{
      py: 1.25,
      px: 2,
      borderRadius: `${NAV_RADIUS}px`,
      transition: navTransition,
      color: selected ? activeText : defaultColor,
      boxShadow: 'none',
      '&.Mui-selected': {
        backgroundColor: activeBg,
        color: activeText,
        '&:hover': {
          backgroundColor: activeBg
        }
      },
      '&:hover': {
        backgroundColor: selected ? activeBg : hoverBg,
        boxShadow: 'none'
      }
    }}>
        <ListItemIcon sx={{
        minWidth: 40,
        color: selected ? activeIcon : defaultIcon,
        transition: navTransition
      }}>
          {icon}
        </ListItemIcon>
        <ListItemText primary={label} primaryTypographyProps={{
        variant: 'body2',
        fontWeight: selected ? 600 : 500,
        fontSize: fs.s_n0_875rem,
        lineHeight: 1.5,
        sx: {
          color: 'inherit',
          transition: navTransition
        }
      }} />
      </ListItemButton>
    </ListItem>;
};
export default NavItem;
